import {CustomFieldValue} from "./race-registration/custom-field-value";
import {CompetitorRegistrationDto} from "./race-registration/competitor-registration-dto";
import {Waypoint} from "./waypoint";
import {RaceRegistration} from "./race-registration/race-registration";
import {RaceCommercialItem} from "./race-commercial-item";
import {RaceAdditionalPricingItem} from "./race-additional-pricing-item";

export class Competitor {
  id?: number;
  profileId?: number;
  raceId?: number;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  nickname?: string;
  sex?: number;
  status?: CompetitorStatus;
  startPosition?: number;
  birthday?: Date;
  dayOfBirth?: number;
  monthOfBirth?: number;
  yearOfBirth?: number;
  category?: number;
  categoryLabel?: string;
  address?: string;
  placeOfResidence?: string;
  country?: string;
  identityCardNumber?: string;
  identityCardIssuer?: string;
  identityCardExpires?: Date;
  club?: string;
  mobilePhone?: string;
  emergencyPhone?: string;
  email?: string;
  emailToken?: string;
  emailVerified?: string;
  tshirt?: number;
  meal?: number;
  transport?: number;
  bestTime?: string;
  licence?: string;
  licenceType?: string;
  grouping?: string;
  comment?: string;
  startNumber?: string;
  startBlock?: number;
  chipNumber?: string;
  fee?: string;
  groupRegistrationCode?: string;
  promoCode?: string;
  eventAccommodationItemId?: number;
  accommodationFrom?: string;
  accommodationTo?: string;
  extra?: string;
  created?: Date;
  modified?: Date;
  userId?: number;
  zip?: string;
  discountId?: number;
  registrationId?: number;
  customFieldValues?: CustomFieldValue[];
  registrationFeeId?: number;
  additionalItemsId?: number[];
  discountCode?: number[];
  teamMembers?: Competitor[];
  nationality?: number;
  discipline?: number;
  controlPointsTimes?: ControlPointTime[];
  laps?: ControlPointTime[];
  startTime?:Date;
  registration?: RaceRegistration;
  raceCommercialItem?: RaceCommercialItem;
  raceAdditionalPricingItems?: RaceAdditionalPricingItem[];


  constructor() {
  }

  static competitorToDto(competitor: Competitor): CompetitorRegistrationDto {
    const dto: CompetitorRegistrationDto = new CompetitorRegistrationDto();

    dto.userId = competitor.userId;
    dto.customFieldValues = competitor.customFieldValues;
    dto.firstName = competitor.firstName;
    dto.lastName = competitor.lastName;
    dto.birthday = competitor.birthday;
    dto.placeOfResidence = competitor.placeOfResidence;
    dto.address = competitor.address;
    dto.city = competitor.placeOfResidence;
    dto.mobilePhone = competitor.mobilePhone;
    dto.emergencyPhone = competitor.emergencyPhone;
    dto.identityCardNumber = competitor.identityCardNumber;
    dto.identityCardIssuer = competitor.identityCardIssuer;
    dto.identityExpiration = competitor.identityCardExpires;
    dto.licence = competitor.licence;
    dto.comment = competitor.comment;
    dto.chipNumber = competitor.chipNumber;
    dto.bestTime = competitor.bestTime;
    dto.club = competitor.club;
    dto.transport = competitor.transport;
    dto.meal = competitor.meal;
    dto.tShirt = competitor.tshirt;
    dto.email = competitor.email;
    dto.country = competitor.country;
    dto.zip = competitor.zip;
    dto.gender = competitor.sex;
    dto.licence = competitor.licence;
    dto.nationality = competitor.nationality;
    dto.nickname = competitor.nickname;
    dto.discipline = competitor.discipline;
    return dto;
  }
}

export enum CompetitorStatus {
  RFP = "RFP",
  RMP = "RMP",
  REG = "REG",
  BIB = "BIB",
  RDY = "RDY",
  STA = "STA",
  FIN = "FIN",
  DSQ = "DSQ",
  DNF = "DNF",
  TLE = "TLE",
  DNS = "DNS"
}

export class ControlPointTime {
  id?: number;
  penaltyMinutes?: number;
  /// in case of finish waypoint set number of checkpoints manually instead of through app automatically, based on
  /// the number of registered waypoints
  lap?: number;
  checkpoints?: number;
  time?: Date;
  chipTime?: Date;
  controlWaypoint?: Waypoint;
  key?: string;


  public static sortControlPointTimes(controlPointTimes: ControlPointTime[] | undefined): ControlPointTime[] {
    if (!controlPointTimes) {
      return [];
    }

    return controlPointTimes.sort((a, b) => {
      if (a.time && b.time) {
        return a.time.getTime() - b.time.getTime();
      }
      return 0;
    });
  }

}


